import t, { pluralize } from "@ext/localization/locale/translate";

const collapsedLabel = (blocks: number): string =>
	`${t("diff.only-changes.unchanged")} ${pluralize(blocks, {
		one: t("diff.only-changes.blocks-one"),
		few: t("diff.only-changes.blocks-few"),
		many: t("diff.only-changes.blocks-many"),
	})}`;

export default collapsedLabel;
